import React, { useEffect, useState } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import O365Settings from '../../../adapter/o365/pages/O365Settings'
import SharePointSettings from '../../../adapter/o365/pages/SharePointSettings'
import O365SettingsService from '../../../adapter/o365/service/O365SettingsService'
import Authorization from '../../Authentication/Authorization'
import { FlipCardContainer } from '../../components/FlipCard'
import ProtectedRoute from '../../components/ProtectedRoute'
import Loading from '../../layout/Loading'
import TokenDatabaseService from '../../service/TokenDatabaseService'
import GatewayType from '../GatewayType'
import AdvancedSettings from './AdvancedSettings'
import ChangeRequest from './ChangeRequest'
import License from './License'
import MasterKey from './MasterKey'
import RootCertificate from './RootCertificate'
import SolrConfig, { SolrConfigFlipCard } from './SolrConfig'
import SsoProxy from './SSOProxy/SsoProxy'
import SyslogIntegration from './SyslogIntegration'
import TokenDatabase from './TokenDatabase'

const baseRoute = '/setting'

const Settings: GatewayType = () => {
  const match = useRouteMatch()
  const [subTabs, setSubTabs] = useState([] as any[])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getSubTabs()
      .then((subTabs) => setSubTabs(subTabs))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Loading isLoading={loading}>
      <Switch>
        {subTabs.map((tab) => (
          <ProtectedRoute key={tab.path} path={tab.path} permissions={tab.permissions} Component={tab.component} />
        ))}
        <Route path={match.path}>
          <FlipCardContainer>
            <SolrConfigFlipCard />
          </FlipCardContainer>
        </Route>
      </Switch>
    </Loading>
  )
}

async function getSubTabs(): Promise<any[]> {
  const settingsAuth = Authorization.settings
  var subTabs = [
    { path: baseRoute + '/license', title: 'License', permissions: settingsAuth.license.view, component: License },
    { path: baseRoute + '/advancedSettings', title: 'Advanced Settings', permissions: settingsAuth.advancedSettings.view, component: AdvancedSettings },
    { path: baseRoute + '/solr', title: 'Solr', permissions: settingsAuth.solrConfig.view, component: SolrConfig },
    { path: baseRoute + '/ssoProxy', title: 'SSO Proxy', permissions: settingsAuth.ssoProxy.view, component: SsoProxy },
    { path: baseRoute + '/keySecurity', title: 'Master Key Security', permissions: settingsAuth.masterKey, component: MasterKey },
    { path: baseRoute + '/changeRequest', title: 'Change Request', permissions: settingsAuth.changeRequest, component: ChangeRequest },
    { path: baseRoute + '/rootCertificate', title: 'Root Certificate', permissions: settingsAuth.rootCertificate.view, component: RootCertificate },
    { path: baseRoute + '/syslogIntegration', title: 'Syslog Integration', permissions: settingsAuth.syslogIntegration.view, component: SyslogIntegration },
  ]
  try {
    const isActivated = await TokenDatabaseService.isActivated()
    if (isActivated) {
      subTabs.push({ path: baseRoute + '/tokenDatabase', title: 'Token Database', permissions: settingsAuth.tokenDatabase.view, component: TokenDatabase })
    }
  } catch (ignored) { }
  try {
    await O365SettingsService.getO365BaseSettings()
    subTabs.push({ path: baseRoute + '/o365Settings', title: 'O365 Settings', permissions: Authorization.settings.o365Setting.view, component: O365Settings })
    subTabs.push({ path: baseRoute + '/sharepointSettings', title: 'SharePoint Settings', permissions: Authorization.settings.o365Setting.view, component: SharePointSettings })
  } catch (ignored) { }
  return subTabs
}

Settings.subTabs = getSubTabs

export default Settings
